<template>
  <div class="bg-grey p-3">
    <div class="bg-white p-4">
      <div v-if="hasResults">
        <books-assigned-row
          can-see-action-from-another-view
          class="border"
          v-for="(item, index) in results"
          :key="index"
          :item="item"
          @open="handlerOpen"
          @close="handlerClose"
          @refresh="() => onSearchHandler(pagination.currentPage)"
        />

        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onSearchHandler"
        />
      </div>

      <custom-result-not-found
        v-if="!hasResults"
        text="No hay Información Disponible."
      />
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import storeMixin from "@/mixin/storeGenerator";
import alertMixin from "@/mixin/alert.mixin";
import inventoryOrderBooksService from "@/services/api/inventoryOrderBooks.api";
import BooksAssignedRow from "@/views/books/inventoryCatalog/Management/components/ResultRow.vue";
import FilterManager from "FilterManager";
import CustomSeparator from "custom-separator";
import CustomResultNotFound from "custom-result-not-found";
import Pagination from "pagination";

const DEFAULT_PAGE_SIZE = 10;

export default {
  name: "BooksAssignedToStudent",
  components: {
    ActionButton,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    BooksAssignedRow
  },
  props: {
    student: {
      Type: Object,
      required: true
    }
  },
  mixins: [alertMixin, storeMixin],
  data: () => ({
    loading: false,
    filter: {},
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    results: []
  }),
  computed: {
    hasResults() {
      return Boolean(this.results?.length);
    },
    resultRowActions() {
      return [];
    }
  },
  async mounted() {
    await this.initData();
  },
  methods: {
    async initData() {
      await this.onSearchHandler();
    },
    async onSearchHandler(currentPage = 1) {
      const { pageSize } = this.pagination;

      const { data } = await inventoryOrderBooksService.getStudentAssignedBooks(
        {
          studentSieId: this.student.id,
          currentPage: currentPage,
          pageSize
        }
      );

      this.results = data.data.map(x => ({
        ...x,
        isOpen: false,
        selected: false
      }));

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count
      };
    },
    async handlerOpen(item) {
      this.results
        .filter(x => x.id !== item.id && x.isOpen)
        .forEach(x => (x.isOpen = false));

      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
    }
  }
};
</script>
